import { getLastStringParamFromUrl } from "@helpers/";
import { useAppContext } from "@helpers/context";
import { addPrefix, analytics } from "@services/analytics";
import { useRouter } from "next/router";
import { CustomButton } from "../../../set/components";

export const CollectionStatusButtons = ({
    reset,
    correctCount,
    totalQuestions,
    student,
    baseAnalyticsEvent,
    playGlobalBackgroundSound,
    set,
    isRapidQuizBlock = false,
    handleNextBlock = null,
}) => {
    const set_id = getLastStringParamFromUrl(1, "set_id");
    const href = `/set/${set_id}/collections`;
    const stars = (correctCount / totalQuestions) * 5;
    const { query, asPath, push } = useRouter();
    const { collection_id } = query;
    const { challenges, setChallenges } = useAppContext();
    const bot = challenges?.filter(
        (c) => c.set_id == set_id && c.collection_id == collection_id,
    )[0]?.bot;

    const buttons = [
        <CustomButton
            key={`cb_1`}
            cta={
                stars == 5
                    ? "Replay"
                    : set.type == "practise_learn_practise"
                    ? "Complete Level"
                    : isRapidQuizBlock
                    ? "Continue parctice"
                    : "Replay Now!"
            }
            icon={isRapidQuizBlock ? undefined : "replay"}
            type={"action"}
            onClick={async () => {
                await analytics.track("score_screen_button_clicked", {
                    state:
                        stars == 5
                            ? "replay"
                            : set.type == "practise_learn_practise"
                            ? "complete"
                            : "replay",
                    order: stars == 5 ? 2 : 1,
                    ...baseAnalyticsEvent,
                });

                const totalStars = (correctCount / totalQuestions) * 5;
                if (totalStars == 5 && bot)
                    setChallenges(
                        challenges?.filter(
                            (c) =>
                                !(
                                    c.set_id == set_id &&
                                    c.collection_id == collection_id
                                ),
                        ),
                    );

                reset({
                    deep: isRapidQuizBlock ? false : true,
                    skipCorrect:
                        stars == 5
                            ? false
                            : set.type == "practise_learn_practise"
                            ? true
                            : false,
                });
            }}
            displayType={
                stars == 5 ? "none" : isRapidQuizBlock ? "none" : "normal"
            }
        />,
        <div key={`d_0`} className="py-2 " />,
        <CustomButton
            key={`cb_2`}
            cta={
                set.type == "practise_learn_practise"
                    ? "Play next level"
                    : stars == 5
                    ? "Play Next!"
                    : isRapidQuizBlock
                    ? "Learn Next!"
                    : "Next"
            }
            icon={isRapidQuizBlock ? undefined : "next"}
            displayType={
                stars == 5 ? "normal" : isRapidQuizBlock ? "normal" : "none"
            }
            href={href}
            type={isRapidQuizBlock ? "action" : "link"}
            onClick={async () => {
                if (isRapidQuizBlock) {
                    handleNextBlock && handleNextBlock();
                    return;
                }
                await analytics.track("score_screen_button_clicked", {
                    state: "next",
                    order: stars == 5 ? 1 : 2,
                    ...baseAnalyticsEvent,
                });
                const totalStars = (correctCount / totalQuestions) * 5;
                if (totalStars == 5 && bot)
                    setChallenges(
                        challenges?.filter(
                            (c) =>
                                !(
                                    c.set_id == set_id &&
                                    c.collection_id == collection_id
                                ),
                        ),
                    );
                playGlobalBackgroundSound && playGlobalBackgroundSound();
            }}
        />,
    ];

    return (
        <>
            <div className="flex flex-col px-8 mt-6">
                <div className="flex flex-col w-full z-10 text-dark-purple text-center items-center">
                    {isRapidQuizBlock ? (
                        <div>
                            {`Yayy!! you cracked this quiz 🚀
                             Let’s continue our learning.`}
                        </div>
                    ) : stars == 5 ? (
                        <div>
                            {bot
                                ? `Woah! Trophy collected 🏆 You just won the challenge by ${bot.name}. 👏👏`
                                : set.type !== "practise_learn_practise"
                                ? `Hurray!! Trophy collected ✅ Play more to win more`
                                : `Yayy!! level completed 🚀 Let’s crack next one`}
                        </div>
                    ) : stars >= 3 ? (
                        <div>
                            {bot
                                ? `Oh, don't worry! You can still win ${bot.name}'s challenge 🏆`
                                : set.type !== "practise_learn_practise"
                                ? `You are just ${
                                      totalQuestions - correctCount
                                  } correct
                              questions away to win trophy 🏆`
                                : `Uh oh!! Collect ${
                                      totalQuestions - correctCount
                                  } more ⭐️’ stars complete the level`}
                        </div>
                    ) : (
                        <div>
                            {bot
                                ? `Oh, don't worry! You can still win ${bot.name}'s challenge 🏆`
                                : set.type !== "practise_learn_practise"
                                ? `Want to win trophy 🏆? Get all answers correct. It's
                                easy! 👇`
                                : `Uh oh!! Collect ${
                                      totalQuestions - correctCount
                                  } more ⭐️’ stars complete the level`}
                        </div>
                    )}
                </div>
            </div>
            <div className="flex flex-col items-center px-4 mt-8 mb-5 w-i">
                {stars == 5 || isRapidQuizBlock ? buttons.reverse() : buttons}
            </div>
        </>
    );
};
